var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { WidgetContent } from '../WidgetContent';
import { TemplateKind } from '../../Model/TemplateKind';
import { Templater } from '../../Template/Templater';
import { ImageType } from '../../Model/ImageType';
import { WidgetType } from '../../Model/WidgetType';
import { TrackerFactory } from '../../Factory/TrackerFactory';
import { ExperimentSegment } from '../../Analytics/ExperimentSegment';
import { DeviceUtil } from '../../Util/DeviceUtil';
import { IconKind } from '../../Model/IconKind';
var RatePlanWidgetContent = /** @class */ (function (_super) {
    __extends(RatePlanWidgetContent, _super);
    function RatePlanWidgetContent(widget, host, type) {
        if (type === void 0) { type = WidgetType.RatePlan; }
        var _this = _super.call(this) || this;
        _this._isPresentational = false;
        _this._tracker = TrackerFactory.getTracker();
        _this._widget = widget;
        _this._host = host;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(RatePlanWidgetContent.prototype, "sort", {
        get: function () {
            return this._widget.sort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RatePlanWidgetContent.prototype, "widgetType", {
        get: function () {
            return this._widget.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RatePlanWidgetContent.prototype, "widgetContent", {
        get: function () {
            return this._widget.content;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RatePlanWidgetContent.prototype, "widgetKey", {
        get: function () {
            return this._widget.key;
        },
        enumerable: false,
        configurable: true
    });
    RatePlanWidgetContent.prototype.getProviderId = function () {
        return this._host ? this._host.providerId.toString() : '';
    };
    RatePlanWidgetContent.prototype.canShow = function () {
        return !!this._widget.content.title
            && !!this._widget.content.button
            && this.getSubmitUrl() !== document.location.href;
    };
    RatePlanWidgetContent.prototype.trackEvent = function (eventName) {
        if (this._isPresentational) {
            return;
        }
        var data = {
            action: eventName,
            provider: this.getProviderId(),
            amount: 1,
            number: 1,
            widgetKey: this.widgetKey
        };
        // HYPONLINE-91
        if (this.isPriceCompareExperimentActivated()) {
            var pcData = Object.assign({}, data, {
                segment: this.getOtaPriceCompareSegment(),
                layout: DeviceUtil.isMobile() ? 'phone' : 'desktop'
            });
            var isInOldSegment = pcData.segment !== 'new';
            var needSkipEvents = isInOldSegment && ((DeviceUtil.isMobile() && eventName !== 'preview') || (!DeviceUtil.isMobile() && eventName !== 'show'));
            if (!needSkipEvents) {
                if (eventName === 'show') {
                    var bfPrice = parseInt(this.widgetContent.minBookingFormPrice.replace(/\D/g, ''), 10);
                    var otaPrice = parseInt(this.widgetContent.minOtaPrice.replace(/\D/g, ''), 10);
                    pcData.priceDifference = otaPrice - bfPrice;
                }
                this._tracker.event('ota-price-compare', pcData);
            }
        }
        this._tracker.event('smart-widget', data);
    };
    RatePlanWidgetContent.prototype.isPriceCompareExperimentActivated = function () {
        return this.widgetKey === '25a6b616-dd8e-46d8-9fa1-5893dc343e42';
    };
    RatePlanWidgetContent.prototype.getOtaPriceCompareSegment = function () {
        return this.isPriceCompareExperimentActivated()
            ? ExperimentSegment.get('ota-price-compare', ['old-1', 'new', 'old-2', 'new'])
            : null;
    };
    RatePlanWidgetContent.prototype.render = function (templateKind, templateMode, submitCb, hideCb, resizeCb, isPresentational) {
        var _this = this;
        if (isPresentational === void 0) { isPresentational = false; }
        this._isPresentational = isPresentational;
        var container = document.createElement('template');
        var template = null;
        var styles = null;
        var segment = this.getOtaPriceCompareSegment();
        switch (templateKind) {
            case TemplateKind.Static:
                styles = require('./TemplateStatic/TemplateStatic.scss');
                template = require('./TemplateStatic/TemplateStatic.html');
                break;
            case TemplateKind.Modal:
                styles = require('./TemplateModal/TemplateModal.scss');
                template = require('./TemplateModal/TemplateModal.html');
                break;
            // HYPONLINE-91
            case TemplateKind.Comparer:
                if (!segment || segment !== 'new') {
                    this.trackEvent('show');
                    return container;
                }
                styles = require('./TemplateCompare/TemplateCompare.scss');
                template = require('./TemplateCompare/TemplateCompare.html');
                break;
            default:
                break;
        }
        if (this._widget) {
            styles = this.updateStyles(this._widget.behavior.styles, styles.toString());
            container.appendChild(this.processStyles(styles));
        }
        // HYPONLINE-91 Добавление было ранее, но условие добавилось позже
        if (templateKind === TemplateKind.Comparer) {
            container.appendChild(this.processComparerTemplate(template, templateMode));
        }
        else {
            container.appendChild(this.processRatePlanTemplate(template, templateMode));
        }
        var iconKind = this._widget.content.iconKind;
        if (this._widget.content.imageType === ImageType.Icon && iconKind) {
            this.processIcon(container.querySelector('[icon]'), iconKind);
        }
        var fontHtmlLinks = this.processFonts(this._widget.behavior.styles);
        for (var i = 0; i < fontHtmlLinks.length; i++) {
            container.appendChild(fontHtmlLinks[i]);
        }
        this.trackEvent('show');
        container.querySelector('[btn-close]').addEventListener('click', function () {
            _this.trackEvent('close');
            if (hideCb) {
                hideCb();
            }
        });
        container.querySelector('[btn-submit]').addEventListener('click', function () {
            _this.trackEvent('submit');
            if (submitCb) {
                submitCb(_this.getSubmitUrl());
            }
        });
        return container;
    };
    RatePlanWidgetContent.prototype.getSubmitUrl = function () {
        var bookingFormUrl = this._host.bookingFormUrl;
        var hasRatePlans = false;
        var hasPromoCode = false;
        var ratePlans = this._widget.ratePlans;
        if (this.type === WidgetType.RatePlan) {
            hasRatePlans = ratePlans && ratePlans.selectedRatePlans && Object.keys(ratePlans.selectedRatePlans).length > 0;
            hasPromoCode = ratePlans && !!ratePlans.promoCode;
        }
        var urlParts = [];
        if (hasRatePlans) {
            urlParts.push('special-offer=' + encodeURIComponent(Object.keys(ratePlans.selectedRatePlans).join(',')));
        }
        if (hasPromoCode) {
            urlParts.push('promo-code-plain=' + encodeURIComponent(ratePlans.promoCode));
        }
        var cashbackId = this._widget.cashbackId;
        var cashbackType = this._widget.cashbackType;
        if (cashbackId) {
            urlParts.push('cashback=' + cashbackId);
            urlParts.push('cashback-type=' + cashbackType);
            urlParts.push('utm_tlsource=TlWidget');
        }
        return [
            bookingFormUrl,
            urlParts.length ? bookingFormUrl.indexOf('?') >= 0 ? '&' : '?' : '',
            urlParts.join('&')
        ].join('');
    };
    RatePlanWidgetContent.prototype.processRatePlanTemplate = function (template, templateMode) {
        var imageUrl = this._widget.content.imageAbsoluteUrl
            ? this._widget.content.imageAbsoluteUrl
            : this._widget.content.imageUrl
                ? this.getBaseUrl() + this._widget.content.imageUrl
                : null;
        var hasImage = this._widget.content.imageType === ImageType.File && !!imageUrl;
        var hasIcon = this._widget.content.imageType === ImageType.Icon && !!this._widget.content.iconKind;
        var html = Templater.parse(template, {
            title: this._widget.content.title,
            text: this._widget.content.text,
            description: this._widget.content.description,
            button: this._widget.content.button,
            iconKind: hasIcon,
            image: hasImage ? imageUrl : false,
            imagePosition: hasImage ? this._widget.content.imagePosition || 'center' : false,
            templateMode: templateMode.toLocaleLowerCase(),
            modifiers: this._widget.content.iconKind === IconKind.Cashback ? '-blend-mode' : ''
        });
        return this.processTemplate(html);
    };
    // HYPONLINE-91
    RatePlanWidgetContent.prototype.processComparerTemplate = function (template, templateMode) {
        var hasImage = this._widget.content.imageType === ImageType.File && !!this._widget.content.imageUrl;
        var hasIcon = this._widget.content.imageType === ImageType.Icon && !!this._widget.content.iconKind;
        var html = Templater.parse(template, {
            title: this._widget.content.title,
            text: this._widget.content.text,
            description: this._widget.content.description,
            button: this._widget.content.button,
            iconKind: hasIcon,
            image: this._widget.content.imageUrl,
            imagePosition: hasImage ? this._widget.content.imagePosition || 'center' : false,
            templateMode: templateMode.toLocaleLowerCase(),
            minBookingFormPrice: this._widget.content.minBookingFormPrice,
            minOtaPrice: this._widget.content.minOtaPrice,
            sourceName: this._widget.content.sourceName,
            onSiteText: this._widget.content.onSiteText
        });
        return this.processTemplate(html);
    };
    return RatePlanWidgetContent;
}(WidgetContent));
export { RatePlanWidgetContent };
